export * from './assign-partial-deep';
export * from './check-class-init';


// WEBPACK FOOTER //
// ./~/angular1-template-loader!./src/shared/index.ts